const homeStrings = {
    seoTitle: "La Estrellita | Home",
    heroQuote1: "Taste The",
    heroQuote2: "Flavor You're",
    heroQuoteHighlight: "Craving",
    categoryShowcaseHighlight: "Find",
    categoryShowcase: "Your Next Favorite Dish",
    categoryShowcaseDescription: "Welcome to La Estrellita, where we bring you the best of Honduran and Mexican cuisine. Explore our menu and discover your next favorite dish.",
    reviews: "Reviews",
    reviewsHeader: "See What Our Customers",
    reviewsHeaderHighlight: "Are Saying",
    review1: "The food is absolutely amazing! The flavors are authentic and the service is top-notch. Highly recommend the tacos and pupusas!",
    review2: "A hidden gem in the city! The atmosphere is cozy and the staff is incredibly friendly. The enchiladas are a must-try!",
    review3: "Best Mexican food I've had in a long time! The tamales are delicious and the margaritas are refreshing. Will definitely be back!",
    review4: "La Estrellita is my go-to spot for comfort food. The pupusas are so good, and the staff always makes me feel welcome. Love this place!",
    review5: "If you're looking for authentic Honduran and Mexican food, look no further. The flavors are incredible and the portions are generous. Can't wait for more",
    review6: "This restaurant is a true delight! The variety of dishes is impressive, and everything I've tried has been fantastic. The service is also excellent, making every visit a pleasure",
    finalCallToActionText: "Come Grab A Bite To Eat",
    finalCallToActionDescription: "At La Estrellita we pride ourselves on serving the best authentic Mexican food in the area. Our chefs use traditional recipes and fresh ingredients to create dishes that will transport you to the heart of Mexico. We look forward to serving you soon!"
};

export default homeStrings;
